import { CollectionInfoState } from '../reducers/collectionInfo';
import { actionTypes } from './actionTypes';

export interface SetCollectionInfoAction {
  type: actionTypes.SET_COLLECTION_INFO;
  payload: CollectionInfoState['collectionInfo'];
}

export const setCollectionInfo = (
  collectionInfo: CollectionInfoState['collectionInfo']
): SetCollectionInfoAction => {
  return {
    type: actionTypes.SET_COLLECTION_INFO,
    payload: collectionInfo,
  };
};
export interface SetLastCollectionAction {
  type: actionTypes.SET_LAST_COLLECTION;
  payload: CollectionInfoState['lastCollection'];
}
export const setLastCollection = (lastCollection: {} | null) => {
  return {
    type: actionTypes.SET_LAST_COLLECTION,
    payload: lastCollection,
  };
};

export interface SetCollectionProductsInfoAction {
  type: actionTypes.SET_COLLECTION_PRODUCTS_INFO;
  payload: CollectionInfoState['productsInfo'];
}

export const setCollectionProducts = (
  productsInfo: CollectionInfoState['productsInfo']
): SetCollectionProductsInfoAction => {
  return {
    type: actionTypes.SET_COLLECTION_PRODUCTS_INFO,
    payload: productsInfo,
  };
};
